import { Directive } from 'vue'
export type IntersectDirectiveBinding = { callback: () => void; options?: IntersectionObserverInit }

export const IntersectDirective = <Directive<HTMLElement, IntersectDirectiveBinding>>{
	mounted(el, binding) {
		if (!binding.value.callback) return

		const options = binding.value.options || {
			threshold: 0.01,
			rootMargin: '0px 0px -300px 0px',
		}

		const observer = new IntersectionObserver(entries => {
			const box = el.getBoundingClientRect()

			if (entries[0].isIntersecting || (box.top && box.bottom <= window.innerHeight)) {
				binding.value.callback()
				binding.modifiers.once && observer.unobserve(el)
			}
		}, options)

		observer.observe(el)
	},
}
